import { twMerge } from 'tailwind-merge'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { api, api_delete } from '../services/api.service'

import Confirm from '../components/confirm'
import Loading from '../components/loading'
import PageHeader from '../components/page-header'
import Table from '../components/table'

import { style } from '../style'

export default function AdminOrganisations() {
    const navigate = useNavigate()
    const [organisations, setOrganisations] = useState(null)
    const [deleteId, setDeleteId] = useState()

    useEffect(() => {
        api(`${process.env.REACT_APP_API_URL}/admin/organisation`).then((x) => setOrganisations(x))
    }, [])

    function deleteConfirm() {
        api_delete(`${process.env.REACT_APP_API_URL}/admin/organisation/${deleteId}`).then((x) => {
            api(`${process.env.REACT_APP_API_URL}/admin/organisation`)
                .then((x) => setOrganisations(x))
                .then((x) => setDeleteId(null))
        })
    }

    if (!organisations) return <Loading></Loading>

    return (
        <>
            <Confirm
                open={!!deleteId}
                cancel={() => setDeleteId(false)}
                confirm={() => {
                    deleteConfirm(deleteId)
                    setDeleteId(null)
                }}
            ></Confirm>

            <PageHeader
                headline={'Organisations'}
                actions={
                    <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={() => navigate('/admin/manage-organisation/new')}>
                        Add organisation
                    </button>
                }
            ></PageHeader>

            <div className='flex'>
                <div className='w-full max-w-5xl pb-20 mx-auto my-10 2xl:max-w-6xl'>
                    <div>
                        <Table
                            data={organisations.map((x) => {
                                return {
                                    ...x,
                                    edit: (
                                        <span className='underline cursor-pointer' onClick={() => navigate(`/admin/manage-organisation/${x._id}`)}>
                                            Edit
                                        </span>
                                    ),
                                    deleteCell: (
                                        <span className='underline cursor-pointer' onClick={() => setDeleteId(x._id)}>
                                            Delete
                                        </span>
                                    ),
                                }
                            })}
                            columns={[
                                {
                                    Header: 'Name',
                                    accessor: 'name',
                                },
                                {
                                    Header: 'Edit',
                                    accessor: 'edit',
                                },
                                {
                                    Header: 'Delete',
                                    accessor: 'deleteCell',
                                },
                            ]}
                        ></Table>
                    </div>
                </div>
            </div>
        </>
    )
}
